import React from 'react';
import type { RootStore } from './store';
import { MobXProviderContext } from 'mobx-react';

export function useStores() {
  const { store } = React.useContext(MobXProviderContext);

  return store as RootStore;
}
